module.exports = __webpack_public_path__ + "static/img/BTAB_svg_inverted.cf6dfe2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BTAB_svg_inverted.svg
// module id = 193
// module chunks = 1